<template>
  <v-card class="mx-4 mt-6 mb-3" style="height:70%;" id="group-brightness">
    <v-card-title class="pb-0" style="word-break: normal">
      <v-row>
        <v-col class="py-0 pr-0">
          <v-card-text
            class="text-uppercase text-h6 font-weight-medium px-0 pt-0"
          >
            Brightness
          </v-card-text>
        </v-col>
        <v-col class="pr-0 py-0 d-flex flex-shrink-1">
          <v-card-text class="px-0 pt-1 text-right" id="use-schedule">
            Use Schedule
          </v-card-text>
        </v-col>
        <v-col cols="1" class="px-0 pb-0 mt-n7 mx-3 d-flex justify-end">
          <v-checkbox :disabled="!brightness" v-model="brightness_use" />
        </v-col>
      </v-row>
    </v-card-title>
    <v-form v-model="brightness">
      <v-menu
        v-model="daytimeMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            class="mx-4"
            id="daytime-brightness"
            filled
            @click:append="daytimeMenu = !daytimeMenu"
            readonly
            v-model="brightness_day_time"
            dense
            label="Daytime Brightness"
            append-icon="mdi-alarm"
          />
        </template>
        <v-time-picker
          v-model="brightness_day_time"
          @input="daytimeMenu = false"
        ></v-time-picker>
      </v-menu>
      <v-slider
        class="mx-3"
        color="primary"
        :min="0"
        :max="100"
        v-model="brightness_day_level"
      >
        <template v-slot:append>
          <v-text-field
            v-model="brightness_day_level"
            single-line
            class="mt-n2"
            append-icon="mdi-percent"
            outlined
            dense
            type="number"
            maxlength="3"
            :rules="[v => v >= 0 || 'No negative numbers']"
            min="0"
            max="100"
            style="width: 95px"
          ></v-text-field>
        </template>
      </v-slider>
      <v-menu
        v-model="nighttimeMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            class="mx-4"
            id="nighttime-brightness"
            filled
            readonly
            v-model="brightness_off_time"
            @click:append="nighttimeMenu = !nighttimeMenu"
            label="Nightime Brightness"
            append-icon="mdi-alarm"
          />
        </template>
        <v-time-picker
          v-model="brightness_off_time"
          @input="nighttimeMenu = false"
        ></v-time-picker>
      </v-menu>
      <v-slider
        class="mx-3"
        :min="0"
        :max="100"
        color="primary"
        v-model="brightness_night_level"
      >
        <template v-slot:append>
          <v-text-field
            v-model="brightness_night_level"
            single-line
            class="mt-n2"
            outlined
            type="number"
            :rules="[v => v >= 0 || 'No negative numbers']"
            maxlength="3"
            min="0"
            max="100"
            hide-details
            append-icon="mdi-percent"
            dense
            style="width: 95px"
          ></v-text-field>
        </template>
      </v-slider>
    </v-form>
  </v-card>
</template>
<script>
import GroupDetailData from '@/mixins/GroupDetailData';
import { MobileView } from '@/mixins';

export default {
  mixins: [GroupDetailData, MobileView],
  data() {
    return { brightness: false, daytimeMenu: false, nighttimeMenu: false };
  },
  watch: {
    brightness() {
      if (!this.brightness) {
        this.details.tablet_settings.brightness_use = false;
      }
    },
  },
  computed: {
    brightness_use: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.brightness_use
          : '';
      },
      set(val) {
        this.details.tablet_settings.brightness_use = val;
      },
    },
    brightness_day_time: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.brightness_day_time
          : '';
      },
      set(val) {
        this.details.tablet_settings.brightness_day_time = val;
      },
    },
    brightness_day_level: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.brightness_day_level
          : '';
      },
      set(val) {
        if (this.details.tablet_settings) {
          this.details.tablet_settings.brightness_day_level = val;
        }
      },
    },
    brightness_off_time: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.brightness_off_time
          : '';
      },
      set(val) {
        this.details.tablet_settings.brightness_off_time = val;
      },
    },
    brightness_night_level: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.brightness_night_level
          : '';
      },
      set(val) {
        if (this.details.tablet_settings) {
          this.details.tablet_settings.brightness_night_level = val;
        }
      },
    },
  },
};
</script>
